import { useUnit } from 'effector-react'

import { css } from '@portal/styled-system/css'

import { useI18n } from '@/shared/lib/i18n'
import { Button } from '@/shared/ui'

import * as model from './model'

export function ForgotPasswordButton() {
    const handleForgotPasswordClick = useUnit(model.forgotPasswordClicked)

    return <PasswordButton onClick={() => handleForgotPasswordClick()} />
}

export function ResetPasswordButton({ email }: { email: string }) {
    const handleResetPasswordClick = useUnit(model.resetPasswordClicked)

    return <PasswordButton onClick={() => handleResetPasswordClick({ email })} />
}

function PasswordButton({ onClick }: { onClick: () => void }) {
    const { i18n } = useI18n()
    return (
        <Button
            variant="plain"
            size="sm"
            data-skip-enter
            onClick={onClick}
            styles={css.raw({ fontFamily: 'notoSans', textWrap: 'nowrap' })}
        >
            {i18n.LINK_FORGOT_PASSWORD}
        </Button>
    )
}
